import { compose, mdsWidget } from 'dojo/_base/declare';
import domAttr from 'dojo/dom-attr';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './QAForm.html?raw';
// NOTE (JS2TS): dropped dead dojo/dijit deps (connect, lang, array, Color, keys, dijit
// _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry, on, dom-style, dom-class, dom-construct, mouse).

class QAForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    occurrenceID: any = null;
    entityID: any = null;
    entity: any = null;
    jsonData: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.placeAt(document.body);
    }

    _loadData(entityID: any): void {
        // request ...
    }

    serializeData(): void {
        var data: any = {
            occurrenceID: this.occurrenceID,
            question: this.inputQuestion.value,
            answer: this.inputAnswer.value
        };

        if (this.entity != null) {
            data.ID = this.entity.ID;
        }

        this.jsonData = data;
    }

    _getDataAttr(): any {
        return this.jsonData;
    }

    _setEntityAttr(entity: any): void {
        this.entity = entity;
        this.onChanged_Entity();
    }

    onChanged_Entity(): void {
        var entity = this.entity;

        if (entity == null) {
            return;
        }

        this.occurrenceID = entity.ref_occurrence.ID;

        domAttr.set(this.authorNameNode, "innerHTML", entity.ref_asker.dispname);
        domAttr.set(this.responderNameNode, "innerHTML", entity.ref_responder.dispname);

        domAttr.set(this.inputQuestion, "value", entity.question);
        domAttr.set(this.inputAnswer, "value", entity.answer);

        this.applyPrivileges();
    }

    applyPrivileges(): void {
        var entity = this.entity;

        var bQuestionWriteable = false;
        var bAnswerWriteable = false;

        if (entity == null) { // neuer Datensatz
            bQuestionWriteable = true;
            bAnswerWriteable = false;
        } else {
            bQuestionWriteable = entity._isAsker == true;
            bAnswerWriteable = entity._isResponder == true;
        }

        if (bQuestionWriteable == true) {
            domAttr.remove(this.inputQuestion, "disabled");
            this.inputQuestion.focus();
        } else {
            domAttr.set(this.inputQuestion, "disabled", "disabled");
        }

        if (bAnswerWriteable == true) {
            domAttr.remove(this.inputAnswer, "disabled");
            this.inputAnswer.focus();
        } else {
            domAttr.set(this.inputAnswer, "disabled", "disabled");
        }
    }

    startup(entity?: any): void {
        super.startup.apply(this, arguments as any);

        if (typeof (entity) == "undefined" || entity == null) {
            this.applyPrivileges();
        }

        else if (typeof (entity) == "object") {
            // entity schon da
            this.set("Entity", entity);
        }

        else if (typeof (entity) == "string") { // ID
            this._loadData(entity);
        }

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

}
QAForm.prototype.declaredClass = 'WidgetCollection.Occurrence.QADialog.QAForm';

export default mdsWidget(QAForm);
